'use client';

import { c as _c } from "react/compiler-runtime";
import { ContentSwitcher } from '@src/components/ContentSwitcher/ContentSwitcher';
import { useLocale } from '@src/i18n/LocaleProvider';
import type { LocaleContentSwitcherProps } from './LocaleContentSwitcher.props';
export const LocaleContentSwitcher = props => {
  const $ = _c(11);
  const {
    items: t0,
    builderBlock,
    previewMode: t1
  } = props;
  let t2;
  if ($[0] !== t0) {
    t2 = t0 === undefined ? [] : t0;
    $[0] = t0;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const items = t2;
  const previewMode = t1 === undefined ? false : t1;
  const {
    locale
  } = useLocale();
  let t3;
  if ($[2] !== locale) {
    t3 = item => item.matchUrlLocale === locale.path;
    $[2] = locale;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const defaultIndex = items.findIndex(t3);
  let t4;
  if ($[4] !== items) {
    t4 = items.map(_temp);
    $[4] = items;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = defaultIndex > -1 ? defaultIndex : 0;
  let t6;
  if ($[6] !== builderBlock || $[7] !== previewMode || $[8] !== t4 || $[9] !== t5) {
    t6 = <ContentSwitcher items={t4} builderBlock={builderBlock} previewMode={previewMode} defaultIndex={t5} />;
    $[6] = builderBlock;
    $[7] = previewMode;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
};
function _temp(item_0) {
  return {
    contentBottom: item_0.contentBottom,
    contentTop: item_0.contentTop,
    title: item_0.title
  };
}